<template>
	<div
		class="fixed inset-y-0 right-0 flex side-over side-width z-50 overflow-y-auto"
	>
		<div class="h-full w-full flex flex-col bg-white shadow-xl">
			<div class="px-6 py-8 bg-blue-50">
				<div class="flex items-start justify-between">
					<div class="flex items-center gap-2">
						<img
							src="@/assets/images/icons/class-diary.png"
							alt=""
						/>
						<div class="text-4xl font-bold text-neutral-700 ml-1.5">
							Nhận xét từng mục tiêu
						</div>
					</div>
					<div class="ml-3 h-7 flex items-center">
						<button
							type="button"
							class="rounded-md text-neutral-400 hover:text-neutral-700"
							@click="$emit('close')"
						>
							<span class="sr-only">Close panel</span>
							<svg
								class="h-6 w-6"
								xmlns="http://www.w3.org/2000/svg"
								fill="none"
								viewBox="0 0 24 24"
								stroke="currentColor"
								aria-hidden="true"
							>
								<path
									stroke-linecap="round"
									stroke-linejoin="round"
									stroke-width="2"
									d="M6 18L18 6M6 6l12 12"
								/>
							</svg>
						</button>
					</div>
				</div>
			</div>
			<div
				class="__goal-management-student-detail py-10 pl-10 pr-6 md-down:px-4 sideover-content"
				v-if="!isLoading"
			>
				<div class="flex items-center">
					<div class="text-neutral-400" style="min-width: 90px">
						Lĩnh vực
					</div>
					<div class="text-neutral-600">
						{{ reportDetail?.goal?.skill?.name }}
					</div>
				</div>
				<div class="flex mt-6">
					<div class="text-neutral-400" style="min-width: 90px">
						Nội dung
					</div>
					<div>
						<div
							class="text-neutral-600 font-semibold"
							v-html="
								reportDetail?.goal?.goal_name ||
								reportDetail?.goal?.name
							"
						></div>
						<div
							class="goal-block text-sm font-medium text-neutral-700 mt-2"
							v-if="
								reportDetail?.goal?.parent?.sub_goal_count > 0
							"
						>
							<div class="flex items-center gap-2">
								<img
									class="w-3 h-3"
									src="@/assets/images/icons/goal-arrow.png"
									alt=""
								/>
								<div>
									{{ reportDetail?.goal?.parent.name }}
								</div>
							</div>
							<div
								class="text-neutral-400 text-xs font-semibold mt-2 flex items-center gap-2 ml-5"
							>
								<div>
									{{
										reportDetail?.goal?.parent
											?.sub_goal_count
									}}
									MỤC TIÊU
								</div>
								<svg
									width="4"
									height="4"
									viewBox="0 0 4 4"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M2.064 3.3C1.644 3.3 1.284 3.156 0.984 2.856C0.684 2.556 0.54 2.196 0.54 1.776C0.54 1.368 0.684 1.02 0.984 0.732C1.284 0.444 1.644 0.3 2.064 0.3C2.472 0.3 2.82 0.444 3.108 0.732C3.396 1.02 3.54 1.368 3.54 1.776C3.54 2.196 3.396 2.556 3.108 2.856C2.82 3.156 2.472 3.3 2.064 3.3Z"
										fill="#94A3B8"
									/>
								</svg>
								<div>KẾT QUẢ</div>
								<div class="progress-bar overflow-hidden">
									<div
										:style="{
											background: $filters.tagResult(
												reportDetail?.goal
													?.complete_percent
											)?.background,
											width:
												reportDetail?.goal
													?.complete_percent + '%',
										}"
										class="h-full"
									></div>
								</div>
								<div
									class="text-neutral-400 text-xs font-semibold"
									v-if="reportDetail?.goal?.complete_percent"
								>
									{{ reportDetail?.goal?.complete_percent }}
								</div>
							</div>
							<div
								class="ml-5 mt-2"
								v-for="g in reportDetail?.goal?.parent
									.sub_goals"
								:key="g.id"
							>
								<div class="flex items-center gap-2">
									<img
										class="w-3 h-3"
										src="@/assets/images/icons/child-goal.png"
										alt=""
									/>
									<div
										:class="{
											'font-semibold':
												g.id === reportDetail?.goal?.id,
										}"
									>
										{{ g.name }}
									</div>
								</div>
								<div class="ml-5 flex items-center gap-2 mt-2">
									<div
										class="text-neutral-400 text-xs font-semibold"
									>
										KẾT QUẢ
									</div>
									<div class="progress-bar overflow-hidden">
										<div
											:style="{
												background: $filters.tagResult(
													g.complete_percent
												)?.background,
												width: g.complete_percent + '%',
											}"
											class="h-full"
										></div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="mt-6">
					<div class="text-neutral-600 font-semibold">Ghi chú</div>
					<div
						class="mt-4 space-y-4 sm:flex sm:items-center sm:space-y-0 sm:space-x-10 justify-between"
					>
						<div class="flex items-center">
							<input
								name="notification-method"
								type="radio"
								class="h-4 w-4 text-yellow-600 border-neutral-400 border-2 focus:ring-yellow-600"
								value="Lặp lại mục tiêu"
								v-model="nextPlan"
							/>
							<label
								@click="nextPlan = 'Lặp lại mục tiêu'"
								class="pl-3 block text-sm font-medium text-neutral-700"
							>
								Lặp lại mục tiêu
							</label>
						</div>
						<div
							class="flex items-center"
							v-if="
								reportDetail?.assessment_report
									?.complete_percent !== '0.0'
							"
						>
							<input
								name="notification-method"
								type="radio"
								class="h-4 w-4 text-yellow-600 border-neutral-400 border-2 focus:ring-yellow-600"
								value="Mục tiêu đã hoàn thành"
								v-model="nextPlan"
							/>
							<label
								@click="nextPlan = 'Mục tiêu đã hoàn thành'"
								class="pl-3 block text-sm font-medium text-neutral-700"
							>
								Hoàn thành mục tiêu
							</label>
						</div>
						<div class="flex items-center">
							<input
								type="radio"
								class="h-4 w-4 text-yellow-600 border-neutral-400 border-2 focus:ring-yellow-600"
								value="Tạm dừng mục tiêu"
								v-model="nextPlan"
							/>
							<label
								@click="nextPlan = 'Tạm dừng mục tiêu'"
								class="pl-3 block text-sm font-medium text-neutral-700"
							>
								Tạm dừng mục tiêu
							</label>
						</div>
					</div>
				</div>
				<div class="mt-6" v-if="getNextPlan(nextPlan) === 'stopped'">
					<Multiselect
						v-model="stoppedReason"
						:options="dropdown"
						:allow-empty="false"
						deselect-label="Đã chọn"
						selectLabel=""
						placeholder="Chọn lí do tạm dừng"
					>
					</Multiselect>
					<div
						v-if="getStopReason(stoppedReason) === 'other'"
						class="mt-2"
					>
						<div
							class="input-group"
							:class="error ? 'error-input' : ''"
						>
							<input
								v-model="reason"
								class="bg-white"
								placeholder="Nhập lí do khác"
								type="text"
							/>
						</div>
						<div class="error text-sienna-600 mt-1" v-if="error">
							Lí do tạm dừng ko được để trống
						</div>
					</div>
				</div>
				<div class="mt-6">
					<div class="text-neutral-600 font-semibold mb-1">
						Nhận xét
					</div>
					<textarea
						v-model="note"
						rows="8"
						:about="`Nhận xét của ${$filters.terminology(
							'teacher'
						)} về mục tiêu này của trẻ`"
						class="note"
					></textarea>
				</div>
				<div
					v-if="
						reportDetail?.assessments &&
						reportDetail?.assessments.length > 0
					"
					class="bg-white mt-8 p-6 shadow-sm rounded-2xl"
				>
					<div class="flex">
						<div
							class="bg-green-500 rounded-full mr-4"
							style="
								width: 16px;
								height: 16px;
								min-height: 16px;
								min-width: 16px;
							"
						></div>
						<div class="font-semibold text-neutral-500 -mt-1">
							Kết quả học của MT trong tháng
						</div>
					</div>
					<apexchart
						:options="chartOptions_"
						:series="series"
						height="500"
						type="line"
					>
					</apexchart>
				</div>
				<div
					v-if="
						reportDetail?.assessments &&
						reportDetail?.assessments?.length > 0
					"
					class="shadow-sm sm:rounded-2xl overflow-hidden mt-8"
				>
					<div class="overflow-x-auto scroll-bar">
						<div
							class="overflow-hidden sm:rounded-t-2xl w-fit min-w-full"
						>
							<table class="min-w-full divide-y text-neutral-200">
								<thead class="bg-neutral-100 h-16">
									<tr>
										<th
											class="px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
											scope="col"
										>
											Ngày
										</th>
										<th
											class="px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
											scope="col"
										>
											Kết quả
										</th>
										<th
											class="px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
											scope="col"
										>
											Cảm xúc
										</th>
										<th
											class="px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
											scope="col"
										>
											Hoạt động
										</th>
										<th
											class="px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
											scope="col"
										>
											Ghi chú
										</th>
									</tr>
								</thead>
								<tbody>
									<tr
										v-for="(
											assessments, index
										) in reportDetail?.assessments"
										:key="index"
										:class="
											index % 2 === 0
												? 'bg-white'
												: 'bg-neutral-50'
										"
										class="text-neutral-700 hover:bg-orange-50 cursor-pointer"
									>
										<td
											class="px-6 py-4 whitespace-nowrap text-neutral-700"
										>
											<div>
												{{
													$filters.formatDateDDMM(
														assessments
															.lesson_report.date
													)
												}}
											</div>
										</td>
										<td
											class="px-6 py-4 whitespace-nowrap text-neutral-700"
										>
											<div>
												<div
													:style="{
														background:
															$filters.tagResult(
																assessments.result
															)?.background,
														color: $filters.tagResult(
															assessments.result
														)?.color,
													}"
													class="mt-1 py-0.5 px-2.5 rounded-full text-neutral-700 h-fit w-fit font-semibold text-sm shadow-input"
												>
													{{ assessments.result }}
												</div>
											</div>
										</td>
										<td
											class="px-6 py-4 whitespace-nowrap text-neutral-700"
										>
											<div>
												<div class="whitespace-normal">
													<img
														v-if="
															assessments
																.lesson_report
																.emotion_scale
														"
														:src="
															require(`@/assets/images/emoji/${
																$filters.emoji(
																	assessments
																		.lesson_report
																		.emotion_scale +
																		''
																).emoji
															}`)
														"
														alt=""
														height="30"
														width="30"
													/>
												</div>
											</div>
										</td>
										<td
											class="px-6 py-4 whitespace-nowrap text-neutral-700"
										>
											<div>
												<div
													v-if="
														assessments.activities
													"
												>
													<div
														v-for="a in assessments.activities"
														:key="a.id"
														class="mb-2"
													>
														{{ a?.name }}
													</div>
												</div>
											</div>
										</td>
										<td
											class="px-6 py-4 whitespace-nowrap text-neutral-700"
										>
											<div>
												<div class="whitespace-normal">
													{{ assessments.note }}
												</div>
											</div>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
			<div v-else class="fixed top-1/2 left-1/2 sideover-content">
				<Loading />
			</div>
			<div class="px-6 py-4 border-t border-yellow-50">
				<div class="flex justify-end">
					<button
						class="button-p text-center whitespace-nowrap w-fit"
						type="button"
						@click="submitAssignmentReport"
					>
						Xác nhận
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
import { $api } from '@/services';
import { defineProps, ref, watch, defineEmits } from 'vue';
import Multiselect from '@suadelabs/vue3-multiselect';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import Loading from '@/components/common/Loading';

const isLoading = ref(true);
const store = useStore();
const route = useRoute();
const reason = ref('');
const stoppedReason = ref('');
const note = ref('');
const nextPlan = ref('');
const error = ref(false);
const id = ref(route.params.id);
const series = ref([]);
const seriesData = ref([]);
const props = defineProps(['sideOverShow', 'reportId', 'goalSelectedId']);
const emit = defineEmits(['submit']);
const reportDetail = ref(null);
const dropdown = ref([
	'Mục tiêu quá khó',
	'Con không hợp tác',
	'Không có cơ hội thực hiện',
	'Tạm dừng mục tiêu vì lý do khác',
]);
const chartOptions_ = ref({
	colors: ['#2AA797'],
	chart: {
		type: 'line',
		zoom: {
			enabled: false,
		},
		animations: {
			enabled: false,
		},
	},
	stroke: {
		width: 3,
	},
	labels: [
		1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
		21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31,
	],
	yaxis: {
		labels: {
			show: false,
		},
		max: 100,
		min: 0,
		tickAmount: 5,
	},
	grid: {
		show: true,
		borderColor: '#F1F5F9',
	},
	markers: {
		size: 8,
		strokeColors: '#fff',
		strokeWidth: 2,
	},
});
watch(
	() => props.sideOverShow,
	(value) => {
		if (value) fetchGoalAssignmentDetail();
	}
);

function getStopReason(value) {
	switch (value) {
		case 'Mục tiêu quá khó':
			return 'too_hard';
		case 'Không có cơ hội thực hiện':
			return 'no_opportunity';
		case 'Con không hợp tác':
			return 'no_cooperation';
		case 'Tạm dừng mục tiêu vì lý do khác':
			return 'other';
	}
}

function getNextPlan(value) {
	switch (value) {
		case 'Mục tiêu đã hoàn thành':
			return 'completed';
		case 'Lặp lại mục tiêu':
			return 'continued';
		case 'Tạm dừng mục tiêu':
			return 'stopped';
	}
}
async function submitAssignmentReport() {
	try {
		if (getStopReason(stoppedReason.value) === 'other' && !reason.value) {
			error.value = true;
			setTimeout(() => {
				error.value = false;
			}, 3000);
			return;
		}
		const payload = {
			assessment_report: {
				note: note.value || '',
				goal_id: reportDetail.value?.goal.id,
				next_plan: getNextPlan(nextPlan.value),
				stopped_reason:
					getNextPlan(nextPlan.value) === 'stopped'
						? getStopReason(stoppedReason.value)
						: '',
				stopped_reason_other:
					getStopReason(stoppedReason.value) === 'other'
						? reason.value
						: '',
			},
		};

		const res = await $api.monthlyReport.updateAssessmentReports(
			id.value,
			props.reportId,
			reportDetail.value?.assessment_report?.id,
			payload
		);

		if (res) {
			await store.dispatch('setAlertMessage', {
				message: 'Xác nhận thành công mục tiêu',
			});
			emit('submit');
		}
	} catch (e) {
		let errorField = e?.response?.data?.errors_by_field;
		if (errorField && errorField['stopped_reason']) {
			await store.dispatch('setAlertMessage', {
				message: 'Bạn hãy chọn lý do tạm dừng mục tiêu',
				type: 'danger',
			});
			return;
		}
		if (errorField && errorField['stopped_reason_other']) {
			await store.dispatch('setAlertMessage', {
				message:
					'Lý do tạm dừng ' +
					errorField['stopped_reason_other'].join(', ') +
					'.',
				type: 'danger',
			});
			return;
		}

		await store.dispatch('setAlertMessage', {
			message:
				e?.response?.data?.errors?.join('<br/>') ||
				'Đã có lỗi xảy ra. Vui lòng thử lại',
			type: 'danger',
		});
	}
}
async function fetchGoalAssignmentDetail() {
	try {
		const { data } = await $api.monthlyReport.assessmentReports(
			id.value,
			props.reportId,
			props.goalSelectedId
		);
		reportDetail.value = data.data;
		note.value = reportDetail.value?.assessment_report?.note;
		nextPlan.value = reportDetail.value?.assessment_report?.next_plan;
		stoppedReason.value =
			reportDetail.value?.assessment_report?.stopped_reason;
		if (stoppedReason.value === 'Khác')
			stoppedReason.value = 'Tạm dừng mục tiêu vì lý do khác';
		reason.value =
			reportDetail.value?.assessment_report?.stopped_reason_other;
		seriesData.value = await data.data?.assessments.map((item) => {
			return +item.complete_percent;
		});
		series.value = [
			{
				name: 'Kết quả buổi học',
				data: seriesData.value,
			},
		];
		isLoading.value = false;
	} catch (e) {
		const error =
			e?.response?.data?.errors.join('<br/>') || 'Đã có lỗi xảy ra';
		await store.dispatch('setAlertMessage', {
			message: error,
			type: 'danger',
		});
	}
}
</script>
<style scoped>
.side-width {
	width: 720px !important;
}
.sideover-content {
	height: calc(100vh - 180px);
	overflow-y: auto;
}
@media (max-width: 768px) {
	.side-width {
		width: 100% !important;
	}
}
</style>
